import {
  Button,
  Dialog,
  Paper,
  Grid,
  IconButton,
  Stack,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  LinearProgress,
  Snackbar,
  Alert,
  Slide,
  DialogTitle,
  DialogActions,
  useMediaQuery,
  tableCellClasses,
  FormControlLabel,
  Checkbox,
  FormControl,
  FormLabel,
  Radio,
  RadioGroup,
  Chip,
  Autocomplete,
  Divider,
  Switch,
} from '@mui/material';
import { useTheme } from '@emotion/react';
import CloseIcon from '@mui/icons-material/Close';
import { Form, Formik } from 'formik';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import * as Yup from 'yup';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { Container } from 'reactstrap';

import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import UIContext from '../../context/UIContext';
import axios from '../../utils/axios';

const StyledTableCell = styled(TableCell)({
  color: 'white !important',
  border: 'solid 1px #dee2e6',
  fontWeight: '800',
  textAlign: 'center',
  backgroundColor: '#47A992',
  padding: 'none',
  whiteSpace: 'nowrap',
});

const DefectSubCategoryInitialValue = {
  DefectCategory: '',
  SubCategoryDescription: '',
  OtherCategoryDescription: '',
  Active: 'yes',
};

const filterInitialValue = {
  searchTerm: '',
  Active: true,
};

const DefectSubCategory = () => {
  const [filterData, setFilterData] = useState(filterInitialValue);
  const [defectSubCategoryTableData, setDefectSubCategoryTableData] = useState([]);
  const [defectSubCategorys, setDefectSubCategorys] = useState([]);
  const [defectCategory, setDefectCategory] = useState([]);
  const [UserId, setUserId] = useState(null);

  const [initialValue, setInitialValue] = useState(DefectSubCategoryInitialValue);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [openDelete, setOpenDelete] = useState(false);

  // snackbar context
  const { openSnackBar, showLoading, hideLoading } = useContext(UIContext);

  // api fetch data
  useEffect(() => {
    const UserId = sessionStorage.getItem('UserId');
    setUserId(UserId);
    getAllDefectSubCategory();
    GetAllHelpData();
  }, []);

  const GetAllHelpData = async () => {
    try {
      showLoading();
      const resData = await axios.get('Master/DefectCategory/GetAllActiveDefectCategory');
      setDefectCategory(resData.data);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  };

  const defectSubCategoryValidationSchema = useMemo(
    () =>
      Yup.object().shape({
        DefectCategory: Yup.object().required('Please select Defect Category'),
        SubCategoryDescription: Yup.string()
          .min(3, ({ min }) => `Minimum ${min} characters required`)
          .max(100, ({ max }) => `Cannot exceed more than ${max} characters`)
          .required('Enter Sub Category Description')
          .test('unique-pair', 'defect category & sub Category combination already exists', (value, { parent }) => {
            const { DefectCategory, SubCategoryDescription } = parent;
            return !defectSubCategorys
              .filter((record) => Number(record.SubCategoryId) !== Number(initialValue.SubCategoryId))
              .some(
                (record) =>
                  Number(record.CategoryId) === Number(DefectCategory?.CategoryId) &&
                  record.SubCategoryDescription?.toLowerCase()?.trim() === SubCategoryDescription?.toLowerCase()?.trim()
              );
          }),
        OtherCategoryDescription: Yup.string()
          .min(3, ({ min }) => `Minimum ${min} characters required`)
          .max(200, ({ max }) => `Cannot exceed more than ${max} characters`),
        Active: Yup.string().oneOf(['yes', 'No'], 'Please select Yes or No').required('Please select Yes or No'),
      }),
    [initialValue, defectSubCategorys]
  );

  async function getAllDefectSubCategory() {
    try {
      showLoading();
      const response = await axios.get('Master/DefectSubCategory/GetAllDefectSubCategory');
      setDefectSubCategorys(response.data);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  async function InsertDefectSubCategory(values) {
    try {
      const { DefectCategory, ...RemaingValues } = values;
      showLoading();
      const response = await axios.post('Master/DefectSubCategory/AddDefectSubCategory', {
        ...RemaingValues,
        DefectCategory: DefectCategory.CategoryId,
        UserId,
      });
      getAllDefectSubCategory();
      openSnackBar('Defect Sub Category Added Successfully!');
      // setFilterData(filterInitialValue);
      setEdit(false);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
    setOpen(false);
  }

  const UpdateDefectSubCategory = async (values) => {
    try {
      const { DefectCategory, ...RemaingValues } = values;
      showLoading();
      await axios.post(`Master/DefectSubCategory/UpdateDefectSubCategory`, {
        ...RemaingValues,
        DefectCategory: DefectCategory.CategoryId,
        UserId,
      });
      getAllDefectSubCategory();
      setInitialValue(DefectSubCategoryInitialValue);
      openSnackBar('Defect Sub Category Updated Successfully!', 'warning');
      // setFilterData(filterInitialValue);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    setOpen(false);
    setEdit(false);
    hideLoading();
  };

  const DeleteDefectSubCategory = async () => {
    try {
      showLoading();
      await axios.delete(`Master/DefectSubCategory/DeleteDefectSubCategory/${deleteId}`);
      const newDefectSubCategory = defectSubCategorys.filter(
        (defectSubCategory) => defectSubCategory.SubCategoryId !== deleteId
      );
      setDefectSubCategorys(newDefectSubCategory);
      setDefectSubCategoryTableData(newDefectSubCategory);
      openSnackBar('Defect Sub Category Deleted Successfully!', 'warning');
      // setFilterData(filterInitialValue);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    handleCloseDelete();
    setDeleteId(null);
    hideLoading();
  };

  const handleEditClick = (values) => {
    const { CategoryId, CategoryDescription, ...RemaingValues } = values;
    const NewValues = { DefectCategory: { CategoryId, CategoryDescription }, ...RemaingValues };
    setInitialValue(NewValues);
  };

  const handleFilterDataChange = (name, value) => {
    setFilterData({ ...filterData, [name]: value });
  };
  useEffect(() => {
    const newTableData = defectSubCategorys.filter(
      (defectCat) =>
        `${defectCat.SubCategoryDescription} ${defectCat.CategoryDescription} ${defectCat.OtherCategoryDescription}`
          .toLowerCase()
          .includes(filterData?.searchTerm?.toLowerCase()) &&
        defectCat.Active?.toLowerCase()?.trim() === (filterData.Active ? 'yes' : 'no')
    );
    if (page > 0) setPage(0);
    setDefectSubCategoryTableData(newTableData);
  }, [defectSubCategorys, filterData]);

  const handleCloseDelete = () => {
    setOpenDelete(false);
    setDeleteId(null);
  };

  const handleCloseDialog = () => {
    setOpen(!open);
    setEdit(false);
    setInitialValue(DefectSubCategoryInitialValue);
  };

  // pagination
  const { emptyRows, totalRows, currentPage } = useMemo(() => {
    const totalRows = defectSubCategoryTableData.length;
    const totalPages = Math.ceil(totalRows / rowsPerPage);
    const currentPage = Math.max(0, Math.min(page, totalPages - 1));
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, totalRows - page * rowsPerPage);

    return { emptyRows, totalRows, currentPage };
  }, [defectSubCategoryTableData, page, rowsPerPage]);

  return (
    <>
      <Container maxWidth={'xl'} sx={{ pt: 2 }} elevation={3}>
        {/* table header */}
        <Grid justifyContent={'space-between'} alignItems={'center'} spacing={2}>
          <Typography
            variant="h5"
            p={1}
            boxShadow={1}
            borderColor="#11235A"
            textAlign={'center'}
            borderRadius={2}
            pl={2}
            color="white"
            sx={{
              // borderRadius: 50,
              background: '#47A992',
              boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
            }}
          >
            <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
              DEFECT SUB CATEGORY MASTER
            </Typography>
          </Typography>
        </Grid>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent={'space-between'}
          alignItems={'center'}
          spacing={2}
          my={3}
          px={3}
        >
          <TextField
            type="text"
            variant="outlined"
            color="secondary"
            label="Search"
            size="small"
            onChange={(e) => {
              handleFilterDataChange('searchTerm', e.target.value);
            }}
            value={filterData.searchTerm}
          />
          <Stack direction="row" alignItems="center" spacing={2}>
            <Typography variant="subtitle2" fontWeight="bold">
              Active
            </Typography>

            {/* Toggle Switch with "Yes" / "No" */}
            <FormControlLabel
              control={
                <Switch
                  checked={filterData.Active}
                  onChange={(e) => {
                    handleFilterDataChange('Active', !filterData.Active);
                  }}
                  color="success"
                />
              }
              label={filterData.Active ? 'Yes' : 'No'}
            />
            <Divider orientation="vertical" flexItem />

            <Button
              variant="outlined"
              color="secondary"
              sx={{ boxShadow: 1 }}
              onClick={() => setOpen(!open)}
              startIcon={<PlaylistAddIcon />}
            >
              Add Defect Sub Category
            </Button>
          </Stack>
        </Stack>
        <TableContainer sx={{ borderRadius: '7px', maxHeight: '450px' }} component={Paper} elevation={2}>
          <Table className="table-bordered" size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <StyledTableCell align="center">S.No</StyledTableCell>
                <StyledTableCell align="left">Defect Category</StyledTableCell>
                <StyledTableCell align="left">Defect Sub Category</StyledTableCell>
                <StyledTableCell align="left">Other Description</StyledTableCell>
                <StyledTableCell align="center">Active</StyledTableCell>
                <StyledTableCell align="center">Actions</StyledTableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {(rowsPerPage > 0
                ? defectSubCategoryTableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                : defectSubCategoryTableData
              ).map((defectSubCategory, i) => (
                <TableRow key={defectSubCategory.SubCategoryId} hover>
                  <TableCell align="center">{page * rowsPerPage + (i + 1)}</TableCell>
                  {/* <TableCell align="center">{defectSubCategory.SNo}</TableCell> */}
                  <TableCell align="left">{defectSubCategory.CategoryDescription}</TableCell>
                  <TableCell align="left">{defectSubCategory.SubCategoryDescription}</TableCell>
                  <TableCell align="left">{defectSubCategory.OtherCategoryDescription}</TableCell>
                  <TableCell align="center">
                    <Chip
                      color={defectSubCategory.Active === 'yes' ? 'success' : 'error'}
                      label={defectSubCategory.Active === 'yes' ? 'Yes' : 'No'}
                      size="small"
                      icon={defectSubCategory.Active === 'yes' ? <CheckCircleOutlineIcon /> : <HighlightOffIcon />}
                    />
                  </TableCell>

                  <TableCell align="center" sx={{ padding: '0' }}>
                    <IconButton
                      aria-label="Edit"
                      onClick={() => {
                        setEdit(true);
                        setOpen(true);
                        handleEditClick(defectSubCategory);
                      }}
                    >
                      <EditIcon color="primary" />
                    </IconButton>
                    <IconButton
                      aria-label="Delete"
                      onClick={() => {
                        setDeleteId(defectSubCategory.SubCategoryId);
                        setOpenDelete(true);
                      }}
                    >
                      <DeleteForeverIcon color="error" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
              {/* {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={11} />
                </TableRow>
              )} */}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={totalRows}
          rowsPerPage={rowsPerPage}
          page={currentPage} // Use the calculated currentPage value
          onPageChange={(event, newPage) => setPage(newPage)}
          onRowsPerPageChange={(event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0); // Reset the page when rowsPerPage changes
          }}
          mt={2}
        />
        <Grid m={2}>
          {/* add new popup form dialog box */}
          <Dialog maxWidth={'sm'} open={open} onClose={handleCloseDialog} fullWidth>
            <Container component={Paper} elevation={2} style={{ padding: '7px 14px' }}>
              <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} mr={1}>
                <Typography variant="h6" textAlign={'left'} pl={2} fontWeight={600} color="primary">
                  {edit ? 'Edit' : 'Add'} Defect Sub Category
                </Typography>
                <IconButton onClick={handleCloseDialog}>
                  <CloseIcon />
                </IconButton>
              </Stack>
              <Stack sx={{ p: 1 }}>
                <Formik
                  validationSchema={defectSubCategoryValidationSchema}
                  initialValues={initialValue}
                  onSubmit={async (values, { resetForm }) => {
                    if (edit) await UpdateDefectSubCategory(values);
                    else await InsertDefectSubCategory(values);
                    resetForm();
                  }}
                >
                  {({ submitForm, values, errors, touched, handleChange, handleBlur, setFieldValue, isSubmitting }) => (
                    <Form>
                      <Grid container spacing={2} p={1} rowSpacing={3}>
                        <Grid item width={'100%'}>
                          <Autocomplete
                            options={defectCategory}
                            getOptionLabel={(defectCat) => defectCat.CategoryDescription}
                            isOptionEqualToValue={(value) => value.CategoryId === values.DefectCategory.CategoryId}
                            renderOption={(props, defectCat) => (
                              <li {...props} key={defectCat.CategoryId}>
                                {defectCat.CategoryDescription}
                              </li>
                            )}
                            value={values.DefectCategory || null}
                            name="DefectCategory"
                            onChange={(event, value) => {
                              setFieldValue('DefectCategory', value);
                            }}
                            size="small"
                            onBlur={handleBlur}
                            renderInput={(params) => (
                              <TextField
                                required
                                {...params}
                                label="Defect Category"
                                error={touched.DefectCategory && !!errors.DefectCategory}
                                helperText={touched.DefectCategory && errors.DefectCategory}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item width={'100%'}>
                          <TextField
                            required
                            fullWidth
                            size="small"
                            label="Defect Sub Category Description"
                            type="text"
                            name="SubCategoryDescription"
                            onBlur={handleBlur}
                            error={!!errors.SubCategoryDescription && touched.SubCategoryDescription}
                            helperText={
                              errors.SubCategoryDescription && touched.SubCategoryDescription
                                ? errors.SubCategoryDescription
                                : ''
                            }
                            value={values.SubCategoryDescription}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item width={'100%'}>
                          <TextField
                            fullWidth
                            multiline
                            rows={3}
                            size="small"
                            label="Other Description"
                            type="text"
                            name="OtherCategoryDescription"
                            onBlur={handleBlur}
                            error={!!errors.OtherCategoryDescription && touched.OtherCategoryDescription}
                            helperText={
                              errors.OtherCategoryDescription && touched.OtherCategoryDescription
                                ? errors.OtherCategoryDescription
                                : ''
                            }
                            value={values.OtherCategoryDescription}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item width={'100%'}>
                          <FormControl size="small" fullWidth component="fieldset">
                            <FormLabel component="legend">Active Status</FormLabel>
                            <RadioGroup
                              row
                              value={values.Active?.trim()}
                              name="Active"
                              onBlur={handleBlur}
                              onChange={handleChange}
                            >
                              <FormControlLabel value="yes" control={<Radio size="small" />} label="Yes" />
                              <FormControlLabel value="No" control={<Radio size="small" />} label="No" />
                            </RadioGroup>
                            {errors.Active && touched.Active && (
                              <Typography
                                variant="caption"
                                color="error"
                                className={errors.Active ? 'shake-helper-text' : ''}
                              >
                                {errors.Active}
                              </Typography>
                            )}
                          </FormControl>
                        </Grid>
                      </Grid>

                      <Stack sx={{ mt: 2 }}>
                        <Button
                          onClick={submitForm}
                          disabled={isSubmitting}
                          fullWidth
                          variant="contained"
                          color={edit ? 'warning' : 'primary'}
                          size="small"
                          sx={{ boxShadow: 1 }}
                        >
                          {edit ? 'Update' : 'Save'}
                        </Button>
                      </Stack>
                    </Form>
                  )}
                </Formik>
              </Stack>
            </Container>
          </Dialog>
        </Grid>
        {/* confirmation dialog */}
        <Dialog open={openDelete} onClose={handleCloseDelete} fullScreen={fullScreen} fullWidth maxWidth="xs">
          <DialogTitle id="responsive-dialog-title">Are you sure you want to delete?</DialogTitle>
          <DialogActions>
            <Button variant="contained" autoFocus onClick={handleCloseDelete} color="primary">
              Cancel
            </Button>
            <Button variant="contained" onClick={DeleteDefectSubCategory} color="error" autoFocus>
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </>
  );
};

export default DefectSubCategory;
